module.exports = __webpack_public_path__ + "static/alberta-475d45a7f588d504ead0c2dde56bea19.png";